import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import moment from "moment";
import ptBR from "date-fns/locale/pt-BR";
import Select from "react-select";

//Context
import { useAuth } from "../../../context/auth";
import { showMessage } from "../../../services/message";

//API
import { api_PUT } from "../../../services/api_service";
import { api_POST } from "../../../services/api_service";

export default function PlanoResiduoModelo({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { session, setLoading } = useAuth();
  const [registro, setRegistro] = useState(null);
  const [permiteEditar, set_permiteEditar] = useState(true);

  const [optionsModelo] = useState([
    { label: "SELECIONE", value: "0" },
    { label: "Global", value: "Global" },
    { label: "Por Fase", value: "Por Fase" },
  ]);

  const { register, handleSubmit, errors, control, setValue, watch, reset } =
    useForm({
      mode: "onBlur",
      defaultValues: {
        modelo: optionsModelo[0] || { label: "SELECIONE", value: "0" },
        descricao: "",
        execucaoDe: "",
        execucaoAte: "",
        preExecucaoDe: "",
        preExecucaoAte: "",
        posExecucaoDe: "",
        posExecucaoAte: "",
      },
    });

  const getModeloData = () => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";
    const modeloList = isRequerimento
      ? item?.requerimentoGerador?.[0]?.requerimentoGeradorModeloPlanoResiduos
      : item?.protocoloGerador?.[0]?.protocoloGeradorModeloPlanoResiduos;
    return modeloList?.length ? modeloList[0] : null;
  };

  const setAllValues = (obra) => {
    const selectFields = {
      modelo: [...optionsModelo],
    };

    const fields = [
      "modelo",
      "descricao",
      "execucaoDe",
      "execucaoAte",
      "preExecucaoDe",
      "preExecucaoAte",
      "posExecucaoDe",
      "posExecucaoAte",
    ];

    fields.forEach((field) => {
      let value = obra[field];

      if (value) {
        if (selectFields[field]) {
          const option = selectFields[field].find((opt) => opt.value === value);
          if (option) {
            setValue(field, option, { shouldValidate: true });
          }
        } else {
          if (
            (field === "execucaoDe" ||
              field === "execucaoAte" ||
              field === "preExecucaoDe" ||
              field === "preExecucaoAte" ||
              field === "posExecucaoDe" ||
              field === "posExecucaoAte") &&
            value
          ) {
            value = new Date(value);
          }
          setValue(field, value, { shouldValidate: true });
        }
      }
    });
  };

  function handleCriarObjetoTipoRequerimento(data) {
    const modelo =
      registro?.requerimentoGerador?.[0]
        ?.requerimentoGeradorModeloPlanoResiduos?.[0];
    const requerimentoGeradorId =
      registro?.requerimentoGerador?.[0]?.requerimentoGerador_Id;

    return [
      {
        ...modelo,
        requerimentoGeradorModeloPlanoResiduos_Id:
          modelo?.requerimentoGeradorModeloPlanoResiduos_Id ?? 0,
        requerimentoGerador_Id: requerimentoGeradorId,
        modelo: data.modelo?.value,
        descricao: data.descricao,
        execucaoDe: data?.execucaoDe ? data.execucaoDe : null,
        execucaoAte: data?.execucaoAte ? data.execucaoAte : null,
        preExecucaoDe: data?.preExecucaoDe ? data.preExecucaoDe : null,
        preExecucaoAte: data?.preExecucaoAte ? data.preExecucaoAte : null,
        posExecucaoDe: data?.posExecucaoDe ? data.posExecucaoDe : null,
        posExecucaoAte: data?.posExecucaoAte ? data.posExecucaoAte : null,
      },
    ];
  }

  function handleCriarObjetoTipoProtocolo(data) {
    const modelo =
      registro?.protocoloGerador?.[0]?.protocoloGeradorModeloPlanoResiduos?.[0];
    const protocoloGeradorId =
      registro?.protocoloGerador?.[0]?.protocoloGerador_Id;

    return [
      {
        ...modelo,
        protocoloGeradorModeloPlanoResiduos_Id:
          modelo?.protocoloGeradorModeloPlanoResiduos_Id ?? 0,
        protocoloGerador_Id: protocoloGeradorId,
        modelo: data.modelo?.value,
        descricao: data.descricao,
        execucaoDe: data?.execucaoDe ? data.execucaoDe : null,
        execucaoAte: data?.execucaoAte ? data.execucaoAte : null,
        preExecucaoDe: data?.preExecucaoDe ? data.preExecucaoDe : null,
        preExecucaoAte: data?.preExecucaoAte ? data.preExecucaoAte : null,
        posExecucaoDe: data?.posExecucaoDe ? data.posExecucaoDe : null,
        posExecucaoAte: data?.posExecucaoAte ? data.posExecucaoAte : null,
      },
    ];
  }

  function handleValidacoesDatas(data) {
    if (data.modelo?.value === "Global") {
      const { execucaoDe, execucaoAte } = data;

      if (!execucaoDe || !execucaoAte) {
        return showMessage(
          "Aviso",
          "Preencha as duas datas de execução.",
          "warning",
          null
        );
      }

      // 2. Se as duas estiverem preenchidas e a data final for menor que a inicial
      if (
        execucaoDe &&
        execucaoAte &&
        moment(execucaoAte).isBefore(moment(execucaoDe), "day")
      ) {
        return showMessage(
          "Aviso",
          "A data 'Execução Até' não pode ser menor que 'Execução De'.",
          "warning",
          null
        );
      }
    }

    if (data.modelo?.value === "Por Fase") {
      const {
        execucaoDe,
        execucaoAte,
        preExecucaoDe,
        preExecucaoAte,
        posExecucaoDe,
        posExecucaoAte,
      } = data;

      // Validar se todos os campos estão preenchidos
      if (
        !preExecucaoDe ||
        !preExecucaoAte ||
        !execucaoDe ||
        !execucaoAte ||
        !posExecucaoDe ||
        !posExecucaoAte
      ) {
        return showMessage(
          "Aviso",
          "Preencha todas as datas obrigatórias.",
          "warning",
          null
        );
      }

      const preDe = moment(preExecucaoDe);
      const preAte = moment(preExecucaoAte);
      const exeDe = moment(execucaoDe);
      const exeAte = moment(execucaoAte);
      const posDe = moment(posExecucaoDe);
      const posAte = moment(posExecucaoAte);

      if (preDe.isAfter(preAte)) {
        return showMessage(
          "Aviso",
          "A Data INÍCIO PRÉ EXECUÇÃO não pode ser maior que a Data FIM PRÉ EXECUÇÃO.",
          "warning",
          null
        );
      }

      if (exeDe.isAfter(exeAte)) {
        return showMessage(
          "Aviso",
          "A Data INÍCIO EXECUÇÃO não pode ser maior que a Data FIM EXECUÇÃO.",
          "warning",
          null
        );
      }

      if (posDe.isAfter(posAte)) {
        return showMessage(
          "Aviso",
          "A Data INÍCIO PÓS EXECUÇÃO não pode ser maior que a Data FIM PÓS EXECUÇÃO.",
          "warning",
          null
        );
      }

      if (exeDe.isBefore(preAte) || posDe.isBefore(exeAte)) {
        return showMessage(
          "Aviso",
          "As Datas de INÍCIO de EXECUÇÃO e PÓS EXECUÇÃO não podem ser MENOR que a Data FIM de EXECUÇÃO PRÉ.",
          "warning",
          null
        );
      }
    }
  }

  const onSubmit = async (data) => {
    if (!data?.modelo?.value || data?.modelo?.value === "0")
      return showMessage(
        "Aviso",
        "Selecione o modelo, por favor!",
        "warning",
        null
      );

    //Validações das datas pelo modelo
    handleValidacoesDatas(data);

    const isRequerimento = opcao.tipoCadastro === "Requerimento";

    if (isRequerimento) {
      setLoading(true);
      try {
        const objRequerimento = handleCriarObjetoTipoRequerimento(data);

        let resposta;
        if (!!objRequerimento[0].requerimentoGeradorModeloPlanoResiduos_Id) {
          resposta = await api_PUT(
            "RequerimentoGerador/PutRequerimentoGeradorModeloPlanoResiduo",
            objRequerimento[0]
          );
        } else {
          resposta = await api_POST(
            "RequerimentoGerador/PostRequerimentoGeradorModeloPlanoResiduo",
            objRequerimento[0]
          );
        }

        const modeloObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.requerimentoGerador?.[0]) {
          registroAtualizado.requerimentoGerador[0].requerimentoGeradorModeloPlanoResiduos =
            [modeloObra];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const objProtocolo = handleCriarObjetoTipoProtocolo(data);

        let resposta;
        if (!!objProtocolo[0].protocoloGeradorModeloPlanoResiduos_Id) {
          resposta = await api_PUT(
            "ProtocoloGerador/PutProtocoloGeradorModeloPlanoResiduo",
            objProtocolo[0]
          );
        } else {
          resposta = await api_POST(
            "ProtocoloGerador/PostProtocoloGeradorModeloPlanoResiduo",
            objProtocolo[0]
          );
        }

        const modeloObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.protocoloGerador?.[0]) {
          registroAtualizado.protocoloGerador[0].protocoloGeradorModeloPlanoResiduos =
            [modeloObra];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    }
  };

  // Observar valor de modelo
  const modelo = watch("modelo");

  useEffect(() => {
    if (session && session.tipoAcesso === "AreaRestrita" && item) {
      set_permiteEditar(true);
    }

    if (item) {
      const modeloData = getModeloData();
      setRegistro(item);
      if (modeloData) {
        setTimeout(() => {
          setAllValues(modeloData);
        }, 100);
      }
    }
  }, [item]);

  return (
    <Card className="card-stats">
      <CardBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Container style={{ maxWidth: "1000px", margin: "0 auto" }}>
            <h2 className="titulo-solicitacao">Plano de Resíduos - Modelo</h2>
            <Row>
              {/* Modelo */}
              <Col md="12" lg="6">
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Modelo
                    </label>
                  </b>

                  <Controller
                    name="modelo"
                    control={control}
                    rules={{ required: true }}
                    render={({ onChange, value }) => (
                      <Select
                        options={optionsModelo}
                        placeholder="Selecione"
                        value={value}
                        onChange={(selected) => {
                          const camposParaLimpar = [
                            "execucaoDe",
                            "execucaoAte",
                            "preExecucaoDe",
                            "preExecucaoAte",
                            "posExecucaoDe",
                            "posExecucaoAte",
                          ];
                          camposParaLimpar.forEach((campo) =>
                            setValue(campo, null)
                          );
                          onChange(selected);
                        }}
                      />
                    )}
                  />

                  {errors.modelo && (
                    <span className="form-control-label text-danger">
                      * Campo obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              {/* Descrição */}
              <Col md="12" lg="6">
                <FormGroup>
                  <b>
                    <label>Descrição</label>
                  </b>
                  <Input
                    type="text"
                    name="descricao"
                    innerRef={register()}
                    readonly={permiteEditar ? false : "readonly"}
                    autoComplete="off"
                    maxLength="50"
                  />
                  {errors.descricao && (
                    <span className="form-control-label text-danger">
                      * Campo obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              {modelo && modelo?.value !== "Por Fase" && (
                <>
                  {/* Execução De */}
                  <Col md="12" lg="6">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>
                        <label>Execução De</label>
                      </b>
                      <Controller
                        name="execucaoDe"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale={ptBR}
                            placeholderText="Selecione a data"
                            wrapperClassName="w-100"
                          />
                        )}
                      />
                      {errors.execucaoDe && (
                        <span className="form-control-label text-danger">
                          * Campo obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Execução Até */}
                  <Col md="12" lg="6">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Execução Até</label>
                      </b>
                      <Controller
                        name="execucaoAte"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale={ptBR}
                            placeholderText="Selecione a data"
                            wrapperClassName="w-100"
                          />
                        )}
                      />
                      {errors.execucaoAte && (
                        <span className="form-control-label text-danger">
                          * Campo obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                </>
              )}

              {modelo && modelo?.value === "Por Fase" && (
                <>
                  <Col md={12} lg={12}>
                    <h4
                      style={{
                        borderBottom: "solid 1px #ccc",
                        width: "100%",
                      }}
                    >
                      PRÉ EXECUÇÃO
                    </h4>
                  </Col>
                  {/* Pre Execução De */}
                  <Col md="12" lg="6">
                    <b>
                      <span className="text-danger">* </span>
                      <label>Pré Execução De</label>
                    </b>
                    <FormGroup>
                      <Controller
                        name="preExecucaoDe"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale={ptBR}
                            placeholderText="Selecione a data"
                            wrapperClassName="w-100"
                          />
                        )}
                      />
                      {errors.preExecucaoDe && (
                        <span className="form-control-label text-danger">
                          * Campo obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Pre Execução Até */}
                  <Col md="12" lg="6">
                    <b>
                      <span className="text-danger">* </span>{" "}
                      <label>Pré Execução Até</label>
                    </b>
                    <FormGroup>
                      <Controller
                        name="preExecucaoAte"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale={ptBR}
                            placeholderText="Selecione a data"
                            wrapperClassName="w-100"
                          />
                        )}
                      />
                      {errors.preExecucaoAte && (
                        <span className="form-control-label text-danger">
                          * Campo obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={12} lg={12}>
                    <h4
                      style={{
                        borderBottom: "solid 1px #ccc",
                        width: "100%",
                      }}
                    >
                      EXECUÇÃO
                    </h4>
                  </Col>
                  {/* Execução De */}
                  <Col md="12" lg="6">
                    <b>
                      <span className="text-danger">* </span>{" "}
                      <label>Execução De</label>
                    </b>
                    <FormGroup>
                      <Controller
                        name="execucaoDe"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale={ptBR}
                            placeholderText="Selecione a data"
                            wrapperClassName="w-100"
                          />
                        )}
                      />
                      {errors.execucaoDe && (
                        <span className="form-control-label text-danger">
                          * Campo obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Execução Até */}
                  <Col md="12" lg="6">
                    <b>
                      <span className="text-danger">* </span>{" "}
                      <label>Execução Até</label>
                    </b>
                    <FormGroup>
                      <Controller
                        name="execucaoAte"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale={ptBR}
                            placeholderText="Selecione a data"
                            wrapperClassName="w-100"
                          />
                        )}
                      />
                      {errors.execucaoAte && (
                        <span className="form-control-label text-danger">
                          * Campo obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={12} lg={12}>
                    <h4
                      style={{
                        borderBottom: "solid 1px #ccc",
                        width: "100%",
                      }}
                    >
                      PÓS EXECUÇÃO
                    </h4>
                  </Col>
                  {/* Pós Execução De */}
                  <Col md="12" lg="6">
                    <b>
                      <span className="text-danger">* </span>{" "}
                      <label>Pós Execução De</label>
                    </b>
                    <FormGroup>
                      <Controller
                        name="posExecucaoDe"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale={ptBR}
                            placeholderText="Selecione a data"
                            wrapperClassName="w-100"
                          />
                        )}
                      />
                      {errors.posExecucaoDe && (
                        <span className="form-control-label text-danger">
                          * Campo obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Pós Execução Até */}
                  <Col md="12" lg="6">
                    <b>
                      <span className="text-danger">* </span>{" "}
                      <label>Pós Execução Até</label>
                    </b>
                    <FormGroup>
                      <Controller
                        name="posExecucaoAte"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <DatePicker
                            selected={value}
                            onChange={onChange}
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale={ptBR}
                            placeholderText="Selecione a data"
                            wrapperClassName="w-100"
                          />
                        )}
                      />
                      {errors.posExecucaoAte && (
                        <span className="form-control-label text-danger">
                          * Campo obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>

            <Row>
              <Col lg="6" className="text-left">
                <Button
                  color="secondary"
                  onClick={() => handleStepAnterior(registro)}
                  className="btn-mobile"
                  type="button"
                >
                  <i className="fas fa-chevron-left"></i> Voltar
                </Button>
              </Col>
              <Col lg="6" className="text-right">
                <Button color="success" className="btn-mobile" type={"submit"}>
                  Próxima Etapa <i className="fas fa-chevron-right"></i>
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </CardBody>
    </Card>
  );
}
